import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetTickets, actionDeleteTicket, actionSendOrderToCook, 
        actionReadyToDeliver, actionDeliverOrder, registerOnChangeOrders,
        actionGetRestaurants, actionSelectRestaurant } from "../../actions/RestaurantActions"
import { actionGetUsersByEmailOrDU } from "../../actions/UserActions"
import { LOGIN_ROUTE, TICKET_ADD_ROUTE, TICKET_EDIT_ROUTE } from "../../config/RoutesConstants"
import Roles from "../../config/RolesConstants"

import { 
  Container, 
  IconButton,
  Badge,
  Button,
  Box, 
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle, 
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
  InputAdornment,
  Select,
  MenuItem
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import CollapseIcon from '@material-ui/icons/ExpandLess';
import CookIcon from '@material-ui/icons/LocalPizza';
import ListIcon from '@material-ui/icons/FormatListBulleted';
import PhoneVerifiedIcon from '@material-ui/icons/CheckCircle';
import PhoneUnverifiedIcon from '@material-ui/icons/Cancel';
// import DeliveryIcon from '@material-ui/icons/DirectionsBike';
// import TakeAwayIcon from '@material-ui/icons/Storefront';
import ToCookIcon  from '@material-ui/icons/Restaurant'
import ToDeliverIcon from '@material-ui/icons/ThumbUp';
import DoneIcon from '@material-ui/icons/Done';
import Util, { ERROR, WARNING } from '../../common/Util'
import { typeInteger, validateEmail, } from "../../common/Validations";
import TakeAwayIcon from "../../common/assets/smallTakeAwayIcon.png"
import DeliveryIcon from "../../common/assets/deliveryIcon.png"
import TableIcon from "../../common/assets/enmesaIcon.png"
import AlertIcon from "../../common/assets/noti_new.png"

const REQUESTED = 'pending';
const COOKING = 'making';
const READY = 'readyToDeliver';
const DELIVERED = 'delivered';
const ASSIGNED = 'assigned';
const ON_THE_WAY = 'ontheway';
const CANCELED = 'canceled';
const TAKEAWAY_TYPE = 'takeAway';
const DELIVERY_TYPE = 'delivery';
const TABLE_TYPE = 'table'
class Tickets extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:25, count:0, tickets:[], filter:{tktState:{}, ordType:{}, name:"", showAll:false}, cookView:false, expanded:{}, view:"list",
                ticketForDelete:false, search:"", delivery:true, takeAway:true, table:true, loadingData:true, changingState:false, showAll:false}    
    this.state[REQUESTED] = true
    this.state.filter.tktState[REQUESTED] = true
    this.state[COOKING] = true
    this.state.filter.tktState[COOKING] = true
    this.state[READY] = true
    this.state.filter.tktState[READY] = true
    this.state[DELIVERED] = true
    this.state.filter.tktState[DELIVERED] = true
    this.state[ASSIGNED] = true
    this.state.filter.tktState[ASSIGNED] = true
    this.state[ON_THE_WAY] = true
    this.state.filter.tktState[ON_THE_WAY] = true
    this.state[CANCELED] = true
    this.state.filter.tktState[CANCELED] = true
    this.state[TAKEAWAY_TYPE] = true
    this.state.filter.ordType[TAKEAWAY_TYPE] = true
    this.state[DELIVERY_TYPE] = true
    this.state.filter.ordType[DELIVERY_TYPE] = true
    this.state[TABLE_TYPE] = true
    this.state.filter.ordType[TABLE_TYPE] = true
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.onChangeDetailView=this.onChangeDetailView.bind(this)
    this.getDeleteTicketSuccess=this.getDeleteTicketSuccess.bind(this)
    this.onAddTicket=this.onAddTicket.bind(this)
    this.onConfirmDeleteTicket=this.onConfirmDeleteTicket.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onSearchKeyPress=this.onSearchKeyPress.bind(this)
    this.onSearchUser=this.onSearchUser.bind(this)
    this.onChangeView=this.onChangeView.bind(this)
    this.types = {"table":"Mesa", "delivery":"Delivery", "takeAway":"Take Away"}

    this.unsubscribe=null
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    let notIsSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})<0)
    if(!this.props.restaurant.id&&notIsSuperAdmin&&this.props.profile.proRestoId){//Si no es super admin y no tiene restaurante seleccionado, busco el restaurante asociado al usuario
      this.props.actionGetRestaurants(
        ()=>{
          const restaurant = this.props.restaurantList&&this.props.restaurantList.filter((r)=>{return r.id = this.props.profile.proRestoId})
          this.props.actionSelectRestaurant(restaurant)
          this.unsubscribe = registerOnChangeOrders(restaurant,()=>{
            this.setState({loadingData:true})
            this.props.actionGetTickets(restaurant, this.state.filter, ()=>{this.onChangePage(null, this.state.page)}, this.getTicketsError)
          })
        }
        ,
        (e)=>{
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "Ocurrió un error al buscar el restaurant.")
        }
        )
    }
    
    if(this.props.restaurant){
      this.unsubscribe = registerOnChangeOrders(this.props.restaurant,()=>{
        this.setState({loadingData:true})
        this.props.actionGetTickets(this.props.restaurant, this.state.filter, ()=>{this.onChangePage(null, this.state.page)}, this.getTicketsError)
      })
    }
  }

  componentWillUnmount(){
    this.unsubscribe&&this.unsubscribe()
  }

  getTicketsError(e){
    console.log("ERROR AL LISTAR TICKETS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tickets.")
  }

  onSearch(evt){
    this.setState({search:evt.target.value})
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    // let filter = new RegExp("M","ig")
    let tickets = []
    tickets = this.props.ticketList||[]
    // .filter((t)=>{
    //   return t.tktBuyerName.match(filter) 
    //       || this.state.takeAway && t.ordType == 'takeAway'
    //       || this.state.delivery && t.ordType == 'delivery'
    //       || this.state[REQUESTED] && t.tktState == REQUESTED
    //       || this.state[COOKING] && t.tktState == COOKING
    //       || this.state[DELIVERED] && t.tktState == DELIVERED
    // }) 
    let count = tickets.length
    let page = newPage
    console.log("PAGINANDO", count, from, end, page)
    if(count<from){
      from = 0;
      end = this.state.rowPerPage
      page = 0
    }
    tickets=tickets&&tickets.slice(from, end)
    this.setState({page:page, count:count, tickets:tickets, loadingData:false, changingState:false})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    // let filter = new RegExp(this.state.filter.name,"ig")
    let tickets = this.props.ticketList||[]
    // .filter((t)=>{
    //   return t.tktBuyerName.match(filter) 
    //       || this.state.takeAway && t.ordType == 'takeAway'
    //       || this.state.delivery && t.ordType == 'delivery'
    //       || this.state[REQUESTED] && t.tktState == REQUESTED
    //       || this.state[COOKING] && t.tktState == COOKING
    //       || this.state[DELIVERED] && t.tktState == DELIVERED
    // })
    let count = tickets.length
    tickets=tickets&&tickets.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, tickets:tickets})
  }

  onAddTicket(){
    this.props.history.push(TICKET_ADD_ROUTE)
  }

  onEditTicket(ticket){
    this.props.history.push(TICKET_EDIT_ROUTE, ticket)
  }

  onConfirmDeleteTicket(){
    this.props.actionDeleteTicket(this.state.ticketForDelete.id, this.state.ticketForDelete.tktOwnerDU,this.getDeleteTicketSuccess,this.getDeleteTicketError)
    this.setState({ticketForDelete:false})
  }

  onDeleteTicket(ticket){
    this.setState({ticketForDelete:ticket})
  }

  getDeleteTicketSuccess(){
    const restaurant = this.props.restaurant
    // console.log("RESTAURANT", restaurant)
    this.props.actionGetTickets(restaurant, this.state.filter, ()=>{this.onChangePage(null,this.state.page)}, this.getTicketsError)
  }

  getDeleteTicketError(e){
    console.log("ERROR GET DELETE TICKET", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el ticket.")
  }

  // isValidSearch(){
  //   let isValid = true
  //   if(!this.state.search){
  //     if(this.state.searchField=="E-mail"){
  //       this.setState({emailError:"Debe ingresar un correo electrónico."})
  //     }else{
  //       this.setState({emailError:"Debe ingresar un número de documento."})
  //     }
  //     isValid=false
  //   }else{
  //     if(this.state.searchField=="E-mail"){//Emails
  //       let errorEmail = validateEmail(this.state.search)
  //       console.log("ERROR MAIL VALIDADO", errorEmail)
  //       if(errorEmail){
  //         this.setState({emailError:errorEmail})
  //         isValid=false
  //       }
  //     }else{//DU
  //       let errorEmail = typeInteger(this.state.search)
  //       if(errorEmail){
  //         this.setState({emailError:errorEmail})
  //         isValid=false
  //       }
  //     }
  //   }
  //   return isValid
  // }

  onSearchKeyPress(evt){
    const k = evt.which || evt.keyCode
    if(k==13) {//ENTER
      this.onSearchUser()
    }
  }

  onSearchUser(){
    // if(this.isValidSearch()){
      let filter = this.state.filter
      filter.name = this.state.search
      this.setState({filter:filter, loadingData:true})
      this.props.actionGetTickets(this.props.restaurant, filter, ()=>{this.onChangePage(null,0)}, this.getTicketsError)
      
    // }
  }

  onChangeTypeCheck(check){
    let newState = {...this.state, loadingData:true}
    newState[check] = !newState[check]
    let filter = {...this.state.filter}
    filter.ordType[check]=newState[check]

    // if(newState[TAKEAWAY_TYPE]){
    //   filter.ordType[TAKEAWAY_TYPE]=true
    // }
    // if(newState[DELIVERY_TYPE]){
    //   filter.ordType[DELIVERY_TYPE]=true
    // }
    // if(newState[TABLE_TYPE]){
    //   filter.ordType[TABLE_TYPE]=true
    // }  
    if(!newState[TAKEAWAY_TYPE]&&!newState[DELIVERY_TYPE]&&!newState[TABLE_TYPE]){
      if(check==TAKEAWAY_TYPE){
        filter.ordType[DELIVERY_TYPE]=true
        newState[DELIVERY_TYPE]=true
      }else{
        filter.ordType[TAKEAWAY_TYPE]=true
        newState[TAKEAWAY_TYPE]=true
      }
        
    }
    newState.filter = filter

    this.setState(newState)
    this.props.actionGetTickets(this.props.restaurant, newState.filter, ()=>{this.onChangePage(null,0)}, this.getTicketsError)

  }

  onChangeStateCheck(check){
    let newState = {...this.state, loadingData:true}
    newState[check] = !newState[check]
    let filter = {...this.state.filter}
    // let filter = {tktState:{}, name:this.state.filter.name, showAll:this.state.filter.showAll}
    filter.tktState[check]=newState[check]
  
    // if(newState[TAKEAWAY_TYPE]&&!newState[DELIVERY_TYPE]){
    //   filter.ordType = TAKEAWAY_TYPE
    // }
    // if(!newState[TAKEAWAY_TYPE]&&newState[DELIVERY_TYPE]){
    //   filter.ordType = DELIVERY_TYPE
    // }
    // if(!newState[TAKEAWAY_TYPE]&&!newState[DELIVERY_TYPE]){
    //   if(check == TAKEAWAY_TYPE){
    //     filter.ordType = DELIVERY_TYPE
    //     newState[DELIVERY_TYPE] = true
    //   }else{
    //     filter.ordType = TAKEAWAY_TYPE
    //     newState[DELIVERY_TYPE] = true
    //   }
    // }
    // if(newState[REQUESTED]){
    //   filter.tktState[REQUESTED]=true
    // }
    // if(newState[COOKING]){
    //   filter.tktState[COOKING]=true
    // }
    // if(newState[READY]){
    //   filter.tktState[READY]=true
    // }  
    // if(newState[DELIVERED]){
    //   filter.tktState[DELIVERED]=true
    // } 
    if(!newState[REQUESTED]&&!newState[COOKING]&&!newState[READY]&&!newState[DELIVERED]&&!newState[ASSIGNED]&&!newState[ON_THE_WAY]&&!newState[CANCELED]){
      if(check==REQUESTED){
        filter.tktState[COOKING]=true
        newState[COOKING]=true
      }else{
        filter.tktState[REQUESTED]=true
        newState[REQUESTED]=true
      }
        
    }
    newState.filter = filter

    this.setState(newState)
    this.props.actionGetTickets(this.props.restaurant, newState.filter, ()=>{this.onChangePage(null,0)}, this.getTicketsError)

  }

  onChangeView(evt){
    this.setState({loadingData:true})
    let value = evt.target.value
    let newState = {...this.state, view:value}
    let filter = {tktState:{}}
    if(value=="cook"){
      newState.cookView=true
      filter.showAll=false
      filter.tktState[COOKING]=true
      filter.tktState[REQUESTED]=false
      filter.tktState[READY]=false
      filter.tktState[DELIVERED]=false
      filter.tktState[ASSIGNED]=false
      filter.tktState[ON_THE_WAY]=false
      filter.tktState[CANCELED]=false
      newState[COOKING]=true
      newState[REQUESTED]=false
      newState[READY]=false
      newState[DELIVERED]=false
      newState[ASSIGNED]=false
      newState[ON_THE_WAY]=false
      newState[CANCELED]=false
    }
    if(value=="list"){
      if(this.state.view == "all"){
        filter = this.state.filter
      }else{
        filter.tktState[COOKING]=true
        filter.tktState[REQUESTED]=true
        filter.tktState[READY]=true
        filter.tktState[DELIVERED]=true
        filter.tktState[ASSIGNED]=true
        filter.tktState[ON_THE_WAY]=true
        filter.tktState[CANCELED]=true
        newState[COOKING]=true
        newState[REQUESTED]=true
        newState[READY]=true
        newState[DELIVERED]=true
        newState[ASSIGNED]=true
        newState[ON_THE_WAY]=true
        newState[CANCELED]=true
      }
      newState.cookView=false
      filter.showAll=false
    }
    if(value=="all"){
      if(this.state.view == "list"){
        filter = this.state.filter
      }else{
        filter.tktState[COOKING]=true
        filter.tktState[REQUESTED]=true
        filter.tktState[READY]=true
        filter.tktState[DELIVERED]=true
        filter.tktState[ASSIGNED]=true
        filter.tktState[ON_THE_WAY]=true
        filter.tktState[CANCELED]=true
        newState[COOKING]=true
        newState[REQUESTED]=true
        newState[READY]=true
        newState[DELIVERED]=true
        newState[ASSIGNED]=true
        newState[ON_THE_WAY]=true
        newState[CANCELED]=true
      }
      newState.cookView=false
      filter.showAll=true
    }
    newState.filter = filter
    
    this.props.actionGetTickets(this.props.restaurant, newState.filter,
       ()=>{
        this.setState(newState)
        this.onChangePage(null,0)
       }, 
      this.getTicketsError)

  }

  onSendToCook(item){
    this.setState({changingState:item.id})
    this.props.actionSendOrderToCook(item, 
      // ()=>this.props.actionGetTickets(this.props.restaurant, this.state.filter, ()=>this.onChangePage(null, this.state.page), this.getTicketsError)
      null
      , 
      (e)=>{
        console.log("ERROR on Send to Cook", e)
        Util.showNoty(ERROR, "Tuvimos problemas para actualizar de " + item.tktBuyerName)
      }
    )
  }

  onReadyToDeliver(item){
    this.setState({changingState:item.id})
    this.props.actionReadyToDeliver(item, null      , 
      (e)=>{
        console.log("ERROR on Ready to Deliver", e)
        Util.showNoty(ERROR, "Tuvimos problemas para actualizar de " + item.tktBuyerName)
      }  
    )
  }

  onDeliver(item){
    this.setState({changingState:item.id})
    this.props.actionDeliverOrder(item, null      , 
      (e)=>{
        console.log("ERROR on Send to Cook", e)
        Util.showNoty(ERROR, "Tuvimos problemas para actualizar de " + item.tktBuyerName)
      }  
    )
  }

  onChangeVisibility(item){
    let expanded = {...this.state.expanded}
    if(expanded[item.id]){
      delete expanded[item.id]
    }else{
      expanded[item.id] = true
    }
    this.setState({expanded:expanded})
  }

  onChangeDetailView(){
    let expandedKeys = Object.keys(this.state.expanded)
    let expanded = {}
    if(expandedKeys.length!=this.state.tickets.length){//Si no estoy mostrando todos, los agrego a todos
      for(let i = 0;i<this.state.tickets.length; i++){
        expanded[this.state.tickets[i].id]=true
      }
    }
    this.setState({expanded:expanded})
  }
  
  /*
  Hora del pedido y fecha:
Franja de entrega:
Tipo: ícono de takeaway o ícono de delivery.
Pedido:(Definir como mostrar el detalle): Nombre del menú, cantidad, 
Nombre: sería el poseedor del ticket
Dirección: (Para cuando es delivery)
Teléfono:
Precio: (Lo que paga el usuario final )
Agregar live data
DNI Poseedor: no va
Orígen no va
RRPP no va
Status si va: Pendiente, enviado a cocina, entregado. TktState
Color no va
Acciones: Marcar como enviado a cocina, como entregado. No puede eliminar. Marcar como entregado.
Detalle de pedido: Al hacer clic sobre la fila, se desplegará debajo el detalle de pedido que incluye los platos + los comentarios del comprador. Fijarse de poner un botón para desplegar todas las descripciones de la tabla.
Filtros: Checkbox para delivery, take away,  buscar por mail. Checkbox por estado

  */

 renderTableHeader(){
    const {theme} = this.props
    const headers = this.state.cookView? ["Nro. de Orden", "Nombre","Comentarios"]
    : ["Nro. de Orden", "Hora del pedido", "Horario TakeAway", "Tipo", "Nombre", "Entregar en", "Teléfono", "Pago", "Efectivo", "Precio Final", "Delivery", "Comentarios" ,"Status"]
    let expandedKeys = Object.keys(this.state.expanded)
    let isExpanded = expandedKeys.length==this.state.tickets.length
    return (
    <TableRow>
      {!this.state.cookView&&<TableCell>
        <Tooltip title={isExpanded?"Ocultar detalle":"Mostrar detalle"}>
          <IconButton onClick={this.onChangeDetailView}>
            {isExpanded?<CollapseIcon/>:<ExpandIcon/>}
          </IconButton>
        </Tooltip>
        </TableCell>}

      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      {!this.state.cookView&&<TableCell style={theme.table.actionsColumn}>Acciones</TableCell>}
    </TableRow>
    )
  }

  renderCard(ord){
    return (
      <Grid item>
        <Card variant="outlined">
          <CardContent>
            <Typography style={{display:"flex", justifyContent:"center", alignItems:"baseline", textAlign:"center"}}>
              <Typography style={{color: "#BC4727", fontSize:22, fontWeight:"bold", paddingRight:4}}>{ord.tktQt}</Typography>
              {ord.tktDisplayName}
            </Typography>
          </CardContent>
        </Card>        
      </Grid>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let tickets = this.state.tickets
    if(!tickets||tickets.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    if(this.state.cookView){
      return tickets.map((item, index)=>{
            return (
              [<TableRow style={theme.table.rowColor}>
                <TableCell>{item.ordNumber}</TableCell>
                <TableCell>{item.tktBuyerName}</TableCell>
                {/* <TableCell>{ord.tktQt}</TableCell>
                <TableCell>{ord.tktDisplayName}</TableCell> */}
                <TableCell>{item.ordComments}</TableCell>
              </TableRow>,
              <TableRow>
                <TableCell colSpan={3}>
                  <Grid container spacing={2} style={{paddingLeft:8}}>
                  {item.orderItems&&item.orderItems.map(this.renderCard)}
                  </Grid>
                </TableCell>
              </TableRow>]
            ) 
      })
    }
    
    return tickets.map((item, index)=>{
      let address = ""
      let addressTooltip = ""
      if(item.ordDeliveryAddress){
        if(item.ordDeliveryAddress.adrStreet&&item.ordDeliveryAddress.adrNumber){
          address = `${item.ordDeliveryAddress.adrStreet} ${item.ordDeliveryAddress.adrNumber}`
        }
        if(item.ordDeliveryAddress.adrFloor){
          address+=` ${item.ordDeliveryAddress.adrFloor}`
        }
        if(item.ordDeliveryAddress.adrDepto){
          address+=` ${item.ordDeliveryAddress.adrDepto}`
        }
        if(item.ordDeliveryAddress.adrBetStreet){
          address+=` ${item.ordDeliveryAddress.adrBetStreet}`
        }
        if(item.ordDeliveryAddress.adrDistrict){
          addressTooltip=`${item.ordDeliveryAddress.adrDistrict}`
        }
        if(item.ordDeliveryAddress.adrLocality){
          addressTooltip+=` ${item.ordDeliveryAddress.adrLocality}`
        }
        if(item.ordDeliveryAddress.adrCity){
          addressTooltip+=` ${item.ordDeliveryAddress.adrCity}`
        } 
      }
      if(item.ordTableNumber){
        address=`Mesa ${item.ordTableNumber}`
      }
      let stateLabel = null 
      let stateTooltip = null
      let stateTooltip2 = null
      let stateTooltip3 = null
      switch(item.tktState){
        case REQUESTED: stateLabel = 'Solicitado';
                        stateTooltip = null
                        break;
        case COOKING: stateLabel = 'En cocina';
                      stateTooltip = null
                        break;
        case READY: stateLabel = item.ordType==TAKEAWAY_TYPE?'Listo para entregar':item.ordType==DELIVERY_TYPE?'Listo para enviar':'Listo para servir';
                    stateTooltip = null
                        break;
        case ASSIGNED: stateLabel = 'Asignado';
                        stateTooltip = item.deliveryData?`${item.deliveryData.proName} ${item.deliveryData.proLastName}`:null
                        stateTooltip2 = item.deliveryData?item.deliveryData.proEmail:null
                        stateTooltip3 = item.deliveryData?item.deliveryData.proPhone:null
                        break;
        case ON_THE_WAY: stateLabel = 'En camino';
                        stateTooltip = item.deliveryData?`${item.deliveryData.proName} ${item.deliveryData.proLastName}`:null
                        stateTooltip2 = item.deliveryData?item.deliveryData.proEmail:null
                        stateTooltip3 = item.deliveryData?item.deliveryData.proPhone:null
                        break;
        case CANCELED: stateLabel = 'Cancelado';
                        stateTooltip = null
                          break;
        case DELIVERED: stateLabel = 'Entregado';
                        stateTooltip = item.ordDeliveryDate&&Util.timestampToMoment(item.ordDeliveryDate).format("HH:mm DD/MM/YYYY")||item.tktControlTime&&Util.timestampToMoment(item.tktControlTime).format("HH:mm DD/MM/YYYY")
                        break;
        default: stateLabel = ''
      }
      let paymentType = item.ordPaymentMethod=='cash'?"Efectivo":"Crédito"
      let isExpanded = this.state.expanded[item.id]
      // console.log("IS VERIFIED PHONE", item.isVerifiedPhone)
      let r = [
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell style={{position:"relative"}}>
      {item.tktState==REQUESTED&&<img src={AlertIcon}  style={{width:30, position:"absolute", left:-20}}/>} 
            <Tooltip title={isExpanded?"Ocultar detalle":"Mostrar detalle"}>
              <IconButton onClick={this.onChangeVisibility.bind(this, item)}>
                {isExpanded?<CollapseIcon/>:<ExpandIcon/>}
              </IconButton>
            </Tooltip>
          </TableCell>
          <TableCell>{item.ordNumber}</TableCell>
          <TableCell style={{width:20}}>{Util.timestampToMoment(item.tktBuyDate).format("HH:mm DD/MM")}</TableCell>
          <TableCell style={{width:20}}>{item.ordTakeAwayTime}</TableCell>
          <TableCell>
            <Tooltip title={this.types[item.ordType]} placement="right">
              {item.ordType==TAKEAWAY_TYPE?
                <img src={TakeAwayIcon} style={{height:"75%"}} alt="Take Away"/>
              :
              (item.ordType==DELIVERY_TYPE?
                <img src={DeliveryIcon} style={{height:"75%"}} alt="Delivery"/>
              : 
              item.ordType==TABLE_TYPE&&
                <img src={TableIcon}  style={{height:"75%"}} alt="Mesa"/> 
              ) 
              }
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title={item.tktBuyerEmail}>
              <Typography>{item.tktBuyerName}</Typography> 
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title={addressTooltip}>
              <Typography>{address}</Typography> 
            </Tooltip>
          </TableCell>
          <TableCell>
            <Typography style={{display:"flex"}}>
            {item.ordPhone} {item.ordPhone?(item.isVerifiedPhone?<PhoneVerifiedIcon style={{fontSize:18, color:"green", marginLeft:4}}/>:<PhoneUnverifiedIcon style={{fontSize:18, color:"red", marginLeft:4}}/>) :null}
            </Typography>
          </TableCell>
          <TableCell>{paymentType}</TableCell>
          <TableCell>{item.ordPayInCashAmmount&&Util.formatCurrency(item.ordPayInCashAmmount)}</TableCell>
          <TableCell>{Util.formatCurrency(item.ordTotal)}</TableCell>
          <TableCell>{Util.formatCurrency(item.ordDeliveryPrice)}</TableCell>
          <TableCell>{item.ordComments}</TableCell>
          <TableCell>
            {stateTooltip?
              <Tooltip title={
                [<Typography style={{fontSize:10, color:"white"}}>
                  {stateTooltip}
                </Typography>,
                <Typography style={{fontSize:10, color:"white"}}>
                  {stateTooltip2}
                </Typography>,
                <Typography style={{fontSize:10, color:"white"}}>
                  {stateTooltip3}
                </Typography>    
                ]
                }>
                <Typography>{stateLabel}</Typography> 
              </Tooltip>
            :
              <Typography style={{color:item.tktState==REQUESTED?"#1EC9A2":undefined}}>{stateLabel}</Typography>}
            </TableCell>
          <TableCell style={{...theme.table.actionsColumn, minWith:200}}>
            {/* <Tooltip title="Editar ticket">
              <IconButton onClick={this.onEditTicket.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip> */}
            {this.state.changingState==item.id?
              <CircularProgress color="primary" size={20}/>
            :
            item.tktState == REQUESTED?
              <Tooltip title="Enviar a cocina">
                <IconButton onClick={this.onSendToCook.bind(this, item)}>
                  <ToCookIcon/>
                </IconButton>
              </Tooltip>
              :(item.tktState == COOKING?
              <Tooltip title={item.ordType==TAKEAWAY_TYPE?'Listo para entregar':item.ordType==DELIVERY_TYPE?'Listo para enviar':'Listo para servir'}>
                <IconButton onClick={this.onReadyToDeliver.bind(this, item)}>
                  <ToDeliverIcon  />
                </IconButton>
              </Tooltip>
              :(item.tktState == READY?
              <Tooltip title="Entregar">
                <IconButton onClick={this.onDeliver.bind(this, item)}>
                  <DoneIcon/>
                </IconButton>
              </Tooltip>
              :null))
            }
          </TableCell>
        </TableRow>
      ]
      if(isExpanded){
        r.push(
          <TableRow>
            <TableCell colSpan={14}>
              <Grid container spacing={2} style={{paddingLeft:8}}>
                {item.orderItems&&item.orderItems.map(this.renderCard)}
              </Grid>
              
            {/* <Table stickyHeader style={{marginLeft:"10%", width:"90%", marginBottom:10}}>
              <TableHead>
                <TableRow>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Nombre</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {item.orderItems.map((ord, i)=>{
                  return (        
                    <TableRow style={i%2==0?theme.table.rowColor:theme.table.row}>
                      <TableCell style={{width:"10%"}}>{ord.tktQt}</TableCell>
                      <TableCell>{ord.tktDisplayName}</TableCell>
                    </TableRow>
              
                    )
                  })}
              </TableBody>
                </Table> */}
            </TableCell>
          </TableRow>
        )
      }
      // console.log("ITEM", isExpanded, r.length, item.id)
      return r
    })
  }

  render(){
    const { theme, ticketList, restaurant } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{restaurant&&restaurant.evtName}</Typography>
            {/* <Typography variant="subtitle1">Crea tickets para el restaurant seleccionado</Typography> */}
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de pedidos</Typography>
            <Toolbar style={theme.table.toolbar}>
              {/* <Tooltip title="Crear nuevo ticket">
                <Fab color="primary" onClick={this.onAddTicket} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip> */}
              {/* <Box> */}
              {/* <Grid container xs={12} style={{justifyContent:"center", alignItems:"center" }}> */}
                {/* <Grid item xs={2}> */}
              <Box style= {{flex:1}}>
                <Box style= {{display:"flex",  justifyContent:"space-between"}}>
                <Input  placeholder="Nombre o Nro. de orden" 
                        onChange={this.onSearch}
                        onKeyPress={this.onSearchKeyPress}
                        value={this.state.search}
                        helperText={this.state.emailError}
                        style={{minWidth:220, marginRight:12}}
                        endAdornment={ 
                          <InputAdornment position="end">
                            <IconButton onClick={this.onSearchUser}>
                              <SearchIcon/>
                            </IconButton>
                          </InputAdornment> 
                        }
                />
              
                    <Select value={this.state.view} onChange={this.onChangeView} style={theme.orders.selectView}>
                      <MenuItem value="cook">Cocina</MenuItem>
                      <MenuItem value="list">Últimos Pedidos</MenuItem>
                      <MenuItem value="all">Todos los Pedidos</MenuItem>
                    </Select>
                {/* </Grid> */}
                </Box>
                {!this.state.cookView&&
                  // <Grid item container xs={8} style={{borderWidth:1, borderRadius:20, borderStyle:"solid"}}>
                  <Box style= {{display:"flex", justifyContent:"space-between"}}>
                    <Box>
                    <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state[REQUESTED]}
                            onChange={()=>this.onChangeStateCheck(REQUESTED)}
                            color="primary"
                            size="small"
                          />
                        }
                        label="Solicitado"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state[COOKING]}
                            onChange={()=>this.onChangeStateCheck(COOKING)}
                            color="primary"
                          />
                        }
                        label="En cocina"
                      />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[READY]}
                          onChange={()=>this.onChangeStateCheck(READY)}
                          color="primary"
                        />
                      }
                      label="Listo para entregar"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[ASSIGNED]}
                          onChange={()=>this.onChangeStateCheck(ASSIGNED)}
                          color="primary"
                        />
                      }
                      label="Asignado"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[ON_THE_WAY]}
                          onChange={()=>this.onChangeStateCheck(ON_THE_WAY)}
                          color="primary"
                        />
                      }
                      label="En camino"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[DELIVERED]}
                          onChange={()=>this.onChangeStateCheck(DELIVERED)}
                          color="primary"
                        />
                      }
                      label="Entregado"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[CANCELED]}
                          onChange={()=>this.onChangeStateCheck(CANCELED)}
                          color="primary"
                        />
                      }
                      label="Cancelado"
                    />
                    </Box>
                    {this.state.loadingData&&<CircularProgress size={20} color="primary"/>}
                    <Box >
                        <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.table}
                            onChange={()=>this.onChangeTypeCheck(TABLE_TYPE)}
                            color="primary"
                          />
                        }
                        label="Mesa"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.takeAway}
                            onChange={()=>this.onChangeTypeCheck(TAKEAWAY_TYPE)}
                            color="primary"
                          />
                        }
                        label="Take Away"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.delivery}
                            onChange={()=>this.onChangeTypeCheck(DELIVERY_TYPE)}
                            color="primary"
                          />
                        }
                        label="Delivery"
                      />
                    </Box>
                  </Box>
                }
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TableFooter>
              <TableRow>
                <TableCell align="right" style={{width:"70%"}}>
                 {this.state.loadingData&&<CircularProgress size={20} color="primary"/>}
                </TableCell>
                {/* {this.state.loadingData&&<CircularProgress size={20} color="primary"/>} */}
                <TableCell align="right">
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    labelRowsPerPage="Pedidos por página"
                    component="div"
                    count={this.state.count}
                    rowsPerPage={this.state.rowPerPage}
                    page={this.state.page}
                    onChangePage={this.onChangePage}
                    onChangeRowsPerPage={this.onChangeRowsPerPage}
                  />
                </TableCell>
              </TableRow>
            </TableFooter>
          </Paper>
          <Dialog open={this.state.ticketForDelete}>
            <DialogTitle>Eliminar Ticket</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el ticket?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({ticketForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar ticket">
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteTicket}>Eliminar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    ticketList: store.evt.ticketList||[],
    restaurant:store.evt.restaurant||{},
    restaurantList: store.evt.restaurantList,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTickets,
      actionReadyToDeliver,
      actionSendOrderToCook, 
      actionDeliverOrder,
      actionDeleteTicket,
      actionGetUsersByEmailOrDU,
      actionSelectRestaurant,
      actionGetRestaurants
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Tickets)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/restaurants/Tickets.js